// mantine
import { Collapse } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
// components
import { PopoverButton } from '@newo/ui-kit';
import { Pencil } from 'lucide-react';
import { TSkill, TSkillData } from '@newo/api/gateway';
import SectionHeading from '@/components/SectionHeading';
import EditSkillForm from '@/modules/Designer/components/Skills/components/EditSkillForm';
// icons
// utils
import { hints } from '@/modules/Designer/Designer.data';

interface SkillSettingsProps {
    className?: string;
    skill: TSkill;
    onUpdate: (skillId: string, data: TSkillData) => void;
}

const SkillSettings = ({ className, skill, onUpdate }: SkillSettingsProps) => {
    const [isOpened, { toggle }] = useDisclosure(true);

    const handleUpdate = async (data: TSkillData) => {
        onUpdate(skill.id, data);
    };

    return (
        <div className={className}>
            <div className="flex flex-nowrap items-center pr-3">
                <SectionHeading
                    hint={hints.skillSettings}
                    isOpened={isOpened}
                    title="Skill settings"
                    onClick={toggle}
                />
                <PopoverButton
                    title="Edit Skill"
                    trigger={<Pencil className="text-sm" />}
                >
                    {(close) => (
                        <EditSkillForm
                            skill={skill}
                            onCancel={close}
                            onSubmit={handleUpdate}
                        />
                    )}
                </PopoverButton>
            </div>
            <Collapse in={isOpened}>
                <div className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-xs p-3">
                    <div>Title:</div>
                    <div className="break-all">{skill.title}</div>
                    <div>Idn:</div>
                    <div className="break-all">{skill.idn}</div>
                    <div>Model:</div>
                    <div className="break-all">
                        {skill.model?.provider_idn}/{skill.model?.model_idn}
                    </div>
                    <div>Runner type:</div>
                    <div className="break-all">{skill.runner_type}</div>
                </div>
            </Collapse>
        </div>
    );
};

export default SkillSettings;
